import dayjs from "dayjs";
import { getAcademicYearRange } from "./academicYear";

export const SERVICE_WINDOW_COLORS = [
	"#2563eb",
	"#7c3aed",
	"#059669",
	"#d97706",
	"#dc2626",
	"#0891b2",
	"#4f46e5",
	"#be185d",
];

export function formatServiceDate(date) {
	if (!date) return "—";
	return dayjs(date).format("DD MMM YYYY");
}

export function isDateInRange(date, startDate, endDate) {
	if (!startDate || !endDate) return false;
	const d = dayjs(date).startOf("day");
	return (
		!d.isBefore(dayjs(startDate).startOf("day")) &&
		!d.isAfter(dayjs(endDate).startOf("day"))
	);
}

export function getTimelineRange(visitTypes, academicYear) {
	const ayRange = getAcademicYearRange(academicYear);
	let start = ayRange.start;
	let end = ayRange.end;

	(visitTypes || []).forEach((visitType) => {
		if (visitType.start_date) {
			const candidate = dayjs(visitType.start_date).startOf("day");
			if (candidate.isBefore(start)) start = candidate;
		}
		if (visitType.end_date) {
			const candidate = dayjs(visitType.end_date).endOf("day");
			if (candidate.isAfter(end)) end = candidate;
		}
	});

	const totalDays = Math.max(end.diff(start, "day"), 1);

	return { start, end, totalDays, label: ayRange.label };
}

export function getBarMetrics(visitType, timeline) {
	if (!visitType?.start_date || !visitType?.end_date || !timeline) {
		return null;
	}

	const start = dayjs(visitType.start_date).startOf("day");
	const end = dayjs(visitType.end_date).endOf("day");
	const offsetDays = Math.max(start.diff(timeline.start, "day"), 0);
	const durationDays = Math.max(end.diff(start, "day") + 1, 1);

	return {
		leftPercent: (offsetDays / timeline.totalDays) * 100,
		widthPercent: Math.min((durationDays / timeline.totalDays) * 100, 100),
		isActive: isDateInRange(dayjs(), visitType.start_date, visitType.end_date),
	};
}

export function getActiveVisitTypes(visitTypes, date = dayjs()) {
	return (visitTypes || []).filter(
		(visitType) =>
			visitType.status !== false &&
			isDateInRange(date, visitType.start_date, visitType.end_date)
	);
}

export function stripHtml(html) {
	if (!html) return "";
	const doc = new DOMParser().parseFromString(html, "text/html");
	return doc.body.textContent || "";
}

export function buildMonthMarkers(timeline) {
	const markers = [];
	let cursor = timeline.start.startOf("month");

	while (cursor.isBefore(timeline.end) || cursor.isSame(timeline.end, "month")) {
		const offsetDays = Math.max(cursor.diff(timeline.start, "day"), 0);
		markers.push({
			key: cursor.format("YYYY-MM"),
			label: cursor.format("MMM YYYY"),
			leftPercent: (offsetDays / timeline.totalDays) * 100,
		});
		cursor = cursor.add(1, "month");
	}

	return markers;
}

export function getTodayMarkerPercent(timeline) {
	const today = dayjs().startOf("day");
	if (today.isBefore(timeline.start) || today.isAfter(timeline.end)) {
		return null;
	}
	const offsetDays = today.diff(timeline.start, "day");
	return (offsetDays / timeline.totalDays) * 100;
}
